<template>
<div>
    <router-link :to="{ name: 'payman_details', params: { hashid: row.id }}" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-eye"></i>
    </router-link>
</div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    methods : {
        world : function() {
           return
        }
    },
})
</script>

<style>

</style>